import { Box, Flex, Text, Spinner } from '@chakra-ui/react'
import { FC } from 'react'
import ReactPaginate from 'react-paginate'

import useTable from '@hook/shared/use-table'

export interface ITableGridPaginationBack {
  udatePageChange?: (page: number) => void
}

const TableGridPaginationBack: FC<ITableGridPaginationBack> = ({
  udatePageChange
}) => {
  const { loading, handlePageChange, pagination } = useTable()

  const handleUpdatePageChange = (page: number) => {
    handlePageChange && udatePageChange(page)
    udatePageChange && handlePageChange(page)
  }

  return (
    <Box pos="relative">
      {loading && (
        <Flex
          top={0}
          h="32px"
          w="100%"
          left={0}
          p="0 24px"
          zIndex={9}
          pos="absolute"
          alignItems="center"
          justifyContent="flex-start"
          bgColor="rgba(255, 255, 255, 0.9)"
        >
          <Spinner size="sm" color="green" />
          <Text ml={4}>Recuperando informações</Text>
        </Flex>
      )}
      <ReactPaginate
        previousLabel={'Anterior'}
        nextLabel={'Próximo'}
        pageCount={pagination ? Number(pagination.totalPages) : 0}
        forcePage={Number(pagination?.actualPage) - 1}
        marginPagesDisplayed={2}
        pageRangeDisplayed={5}
        activeClassName={'active'}
        containerClassName="pagination"
        onPageChange={({ selected }) => handleUpdatePageChange(selected + 1)}
      />
    </Box>
  )
}

export default TableGridPaginationBack
